export enum UserRole {
    ARCHITECT = 'architect',
    EVALUATOR = 'evaluator',
    GUEST = 'guest',
    NOT_LOGGED_IN = 'visitor'
}
